<div>
  <h1 class="text-2xl mb-4 flex items-center gap-4">
    Interessen
    <a routerLink="new"
       class="w-8 h-8 text-white bg-blue-700 hover:bg-blue-800 rounded-full">
      <svg class="text-white" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg"
           aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"></path>
      </svg>
    </a>
  </h1>

  <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
      <tr>
        <th scope="col" class="px-6 py-3">
          Text Unternehmen
        </th>
        <th scope="col" class="px-6 py-3">
          Text Schüler
        </th>
        <th scope="col" class="px-6 py-3">
          Beschreibung
        </th>
        <th scope="col" class="px-6 py-3">
          Interessensgruppe
        </th>
        <th scope="col" class="px-6 py-3">
          Aktiv
        </th>
        <th scope="col" class="px-6 py-3">
          Aktionen
        </th>
      </tr>
      </thead>
      <tbody>
      <tr class="bg-white border-b hover:bg-gray-50" *ngFor="let interest of interests">
        <td class="px-6 py-4">
          <input type="text" name="textForCompany"
                 class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                 [(ngModel)]="interest.textForCompany">
        </td>
        <td class="px-6 py-4">
          <input type="text" name="textForCompany"
                 class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                 [(ngModel)]="interest.textForStudent">
        </td>
        <td class="px-6 py-4">
          <textarea name="textForCompany"
                    rows="5"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    [(ngModel)]="interest.description"></textarea>
        </td>
        <td>
          <label for="interestGroupId" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Interessensgruppe
          </label>
          <select id="interestGroupId"
                  [(ngModel)]="interest.interestGroupId"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option *ngFor="let interestGroup of interestGroups" [value]="interestGroup.id">
              {{ interestGroup.name }}
            </option>
          </select>
        </td>
        <td>
          <label class="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" [checked]="interest.active" class="sr-only peer" name="active"
                   [(ngModel)]="interest.active">
            <div
              class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-red-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
          </label>
        </td>
        <td class="px-6 py-4">
          <button type="submit"
                  (click)="updateInterest(interest)"
                  class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            {{ 'global.ui.save' | translate }}
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
